<template>
  <vue-good-table
    styleClass="vgt-table bordered"
    theme="polar-bear"
    :line-numbers="true"
    :columns="columns"
    :rows="rows"
    :search-options="{
      enabled: true,
      externalQuery: searchTerm,
    }"
    :pagination-options="{
      enabled: true,
      perPage: pageLength,
    }"
    class="com-details mb-50"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field === 'container.ref'">
        <span v-if="props.row.container.reference && typeof props.row.container.reference =='string'">Old value: {{props.row.container.reference}} </span>
        <span v-else>No value yet </span>
        <b-form-group label-for="ref"
        >
          <v-select
            id="ref"
            placeholder="Container reference"
            v-model="props.row.container.reference"
            :options="props.row.container.optionRef"
            item-text="title"
            label="title"
            @input="saveContainerRef(props.row)"
          />
        </b-form-group>
      </span>
    </template>
    <!-- pagination -->
    <template slot="pagination-bottom" slot-scope="props">
      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap"> Showing 1 to </span>
          <b-form-select
            v-model="pageLength"
            :options="['3', '5', '10']"
            class="mx-1"
            @input="(value) => props.perPageChanged({ currentPerPage: value })"
          />
          <span class="text-nowrap"> of {{ props.total }} entries </span>
        </div>
        <div>
          <b-pagination
            :value="1"
            :total-rows="props.total"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => props.pageChanged({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </template>
  </vue-good-table>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import {
  BPagination,
  BFormSelect,
  BForm,
  BFormGroup,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import axios from "@axios";

export default {
  name: "BookingContainer",
  components: {
    ToastificationContent,
    VueGoodTable,
    BPagination,
    BFormSelect,
    BFormGroup,
    BForm,
    BButton,
    vSelect,
  },
  props: {
    containerRefData: Array,
    idBooking: String,
  },
  data() {
    return {
      dataContainer: null,
      containerTab: [],
      pageLength: 3,
      rows: [],
      searchTerm: "",
      columns: [
        {
          label: "Ref",
          field: "container.ref",
          filterOptions: {
            enabled: true,
            placeholder: "",
          },
        },
        {
          label: "Type",
          field: "container.containerType",
          filterOptions: {
            enabled: true,
            placeholder: "",
          },
        },
        {
          label: "Quantity",
          field: "container.quantity",
          filterOptions: {
            enabled: true,
            placeholder: "",
          },
        },
        {
          label: "Weight",
          field: "container.weight",
          filterOptions: {
            enabled: true,
            placeholder: "",
          },
        },
        // {
        //   label: "Save reference",
        //   field: "container.save",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "",
        //   },
        // },
      ],
    };
  },
   
  async mounted() {
    console.log("created", this.containerRefData);
    this.rows = this.containerRefData;
    // await this.getContainer();
    // await this.getContainer()
  },
  methods: {
    async saveContainerRef(data) {
      console.log("data",data,this.idBooking);
       await axios
         .patch("https://mtl-feeder-nodejs.onrender.com/api/bookings/"+this.idBooking, 
         {
           commodityContainerId: data._id,
           reference: data.container.reference.title,
         }
         )
        .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Reference updated",
                    icon: "EditIcon",
                    variant: "success",
                },
                }); 
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },

    // async getContainer() {
    //   this.containerTab = [];
    //   // container
    //   await axios
    //     .get("https://mtl-feeder-nodejs.onrender.com/api/containers")
    //     .then((response) => {
    //       this.containerRefData.forEach((item, index) => {
    //         this.containerTab[index] = [];
    //       response.data.data.forEach((element, i) => {
    //         var containerName = "Container " + element.sizeType;
    //         if (item.container.containerType == containerName) {
    //           this.containerTab[index].push({
    //             title: element.title,
    //             label: element.title,
    //             id: element._id,
    //           });
    //         }
    //       });
    //       })
    //             console.log("containerRefData", this.containerRefData,this.containerTab);

    //     })
    //     .catch((error) => {
    //       this.errorMessage = error.message;
    //     });
    // },
  },
};
</script>

<style>
.com-details .vgt-table.polar-bear td {
  padding: 0.6em 0 0.6em 0 !important;
  text-align: center;
  vertical-align: middle !important;
}
.column-desc {
  padding-left: 10px;
  text-align: left !important;
  max-height: 120px;
  overflow-y: auto;
  margin-bottom: 0 !important;
}
</style>